import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DDocumento } from '@dian/api-formulario';

export interface QuestionItem {
  question: string;
  field: string;
  labelYes: string;
  labelNo: string;
}

export interface ValueChange {
  field: string;
  value: string;
}

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.css']
})
export class QuestionComponent implements OnInit {

  @Input('questionModel') questionModel: QuestionItem = {
    question: '',
    field: '',
    labelYes: 'Si',
    labelNo: 'No'    
  };
  @Input('model') model: DDocumento = new DDocumento();
  @Input('radioVisible') radioVisible: Boolean =new Boolean() ;
  @Output('changeValue') changeValue: EventEmitter<ValueChange> = new EventEmitter<ValueChange>();

  constructor() { }

  ngOnInit() {
  }

  emitData(question: QuestionItem, value: string) {
    this.changeValue.emit({
      field: question.field,
      value: value
    });
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/question/question.component.ts